import { CONFIRMING_METHOD } from "./method.js";
import { capabilityOfTool, isNeverProtected } from "./capability.js";
import { confirmationInForceOf } from "./state.js";
const ALLOWED = Object.freeze({ kind: "allowed" });
/** The gate's decision for one tool line (design §40.8.3). Pure. */
export function protectedCapabilityDecisionOf(input) {
    // The family is consulted before the name (SEC-2 F4): a customer's own operation named `end_conversation` is still a
    // connection operation.
    if (isNeverProtected(input.toolName, input.family))
        return ALLOWED;
    const requirement = input.requirement;
    if (requirement === null)
        return ALLOWED;
    const capability = capabilityOfTool(input.toolName, input.family);
    const protectedAs = capability !== null && requirement.protectedCapability.includes(capability)
        ? capability
        : requirement.everyTool
            ? "every_tool"
            : null;
    if (protectedAs === null)
        return ALLOWED;
    const inForce = confirmationInForceOf(input.state);
    if (inForce !== null && inForce.everyMethod.some((method) => requirement.satisfiedBy.includes(method)))
        return ALLOWED;
    const offered = new Set(input.available);
    const availableMethod = CONFIRMING_METHOD.filter((method) => offered.has(method) && requirement.satisfiedBy.includes(method));
    return Object.freeze({ kind: "refused", capability: protectedAs, availableMethod: Object.freeze(availableMethod) });
}
// ---- the fixed result a refused call is answered with (design §40.8.4) -------------------------------------------------
/** The `result` value of a refused protected tool call. */
export const CONFIRMATION_REQUIRED = "confirmation_required";
/** The instruction of every `confirmation_required` result (design §40.8.4), verbatim. */
export const CONFIRMATION_REQUIRED_INSTRUCTION = "Before doing this you must confirm who you are talking to. Tell the person briefly, offer the available method in " +
    "your own words, and call request_confirmation_code only after they agree. Never ask them to read a code to you and " +
    "never repeat a code: the system listens for it and tells you the outcome. If no method is available, say you cannot " +
    "help with this here.";
/** The fixed result for a refused decision (the runtime serialises it as the tool result). */
export function confirmationRequiredResultOf(decision) {
    return Object.freeze({
        result: CONFIRMATION_REQUIRED,
        available_method: decision.availableMethod,
        instruction: CONFIRMATION_REQUIRED_INSTRUCTION,
    });
}
//# sourceMappingURL=decision.js.map